import { env } from "../env";
import { CONTENT_ENDPOINTS } from "./endpoints";
import { getBearerToken } from "./apiService";
import { getInvalidUploadFilenameMessage, isUploadFilenameValid } from "../utils/fileUploadValidation";

const RAW_BASE_URL = env.REACT_APP_API_URL || "/api";
const BASE_URL = RAW_BASE_URL.endsWith("/api") ? RAW_BASE_URL : `${RAW_BASE_URL}/api`;

const uploadFile = (file, endpoint, onProgress) => {
    if (!isUploadFilenameValid(file?.name)) {
        throw new Error(getInvalidUploadFilenameMessage());
    }

    const formData = new FormData();
    formData.append("file", file);

    const token = getBearerToken();

    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener("progress", (event) => {
            if (!onProgress || !event.lengthComputable) return;
            onProgress(Math.round((event.loaded / event.total) * 100));
        });

        xhr.addEventListener("load", () => {
            if (xhr.status === 413) {
                reject(new Error("File is too large. Please try a smaller file."));
                return;
            }
            try {
                const data = JSON.parse(xhr.responseText || "{}");
                if (xhr.status >= 200 && xhr.status < 300 && data.success) {
                    resolve({
                        mediaUrl: data.mediaUrl,
                        cloudflareId: data.cloudflareId,
                    });
                    return;
                }
                reject(new Error(data.error || `Upload failed (${xhr.status}).`));
            } catch {
                reject(new Error("Upload failed. Please try again."));
            }
        });

        xhr.addEventListener("error", () => reject(new Error("Network error during upload.")));
        xhr.addEventListener("abort", () => reject(new Error("Upload cancelled.")));

        xhr.open("POST", `${BASE_URL}${endpoint}`);
        if (token) {
            xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        }
        xhr.send(formData);
    });
};

export const uploadImageToCloudflare = (file, onProgress) =>
    uploadFile(file, CONTENT_ENDPOINTS.UPLOAD_MEDIA, onProgress);

export const uploadVideoToCloudflare = (file, onProgress) =>
    uploadFile(file, CONTENT_ENDPOINTS.UPLOAD_VIDEO, onProgress);
